// extracted by mini-css-extract-plugin
export default {"container":"styles__container--yk6x7","top":"styles__top--W6y6n","bottom":"styles__bottom--9HbAy"};